
import { OrderOutsideIndiaModel } from "../Model/OrderOutsideIndiaModel";
import config from '../config.json';

export function OrderOutsideIndiaUtilityAddUpdate(ItemDetails: any, ActionType: any, index: any = 0, _Quantity: any) {

    let model = {
        Item_Id: ItemDetails?.Item_Id,
        Item_Title: ItemDetails?.Item_Title,
        Item_Title_Url : ItemDetails?.Item_Title_Url,
        Quantity: _Quantity,
        Item_Url : config["ProdUrl"] +"/" + ItemDetails?.Item_Title_Url + "-" + ItemDetails?.Item_Id
    }

    let _OrderOutsideIndia: any = localStorage.getItem("OrderOutsideIndia");

    let OrderOutsideIndia: Array<OrderOutsideIndiaModel> = [];
    if (_OrderOutsideIndia !== undefined && _OrderOutsideIndia !== null && _OrderOutsideIndia !== "") {
        OrderOutsideIndia = OrderOutsideIndia.concat(JSON.parse(_OrderOutsideIndia));
    }

    if (ActionType === 'Add') {
        if (OrderOutsideIndia === undefined || OrderOutsideIndia === null || OrderOutsideIndia.length === 0) {
            localStorage.setItem("OrderOutsideIndia", JSON.stringify(model));
        }
        else {
            let isItemExists: any = OrderOutsideIndia.filter(x => x.Item_Id === ItemDetails?.Item_Id).length;
            if (isItemExists > 0) {
                let _index = OrderOutsideIndia.findIndex(x => x.Item_Id === ItemDetails?.Item_Id);
                OrderOutsideIndia[_index].Quantity = OrderOutsideIndia[_index].Quantity + 1;
                localStorage.setItem("OrderOutsideIndia", JSON.stringify(OrderOutsideIndia));
            }
            else {
                let AddMPCart = JSON.stringify(OrderOutsideIndia.concat(model));
                localStorage.setItem("OrderOutsideIndia", AddMPCart);
            }
        }
    }
    else if (ActionType === 'Update') {
        OrderOutsideIndia[index].Quantity = _Quantity;
        localStorage.setItem("OrderOutsideIndia", JSON.stringify(OrderOutsideIndia));
    }
    else if (ActionType === 'Delete') {

        OrderOutsideIndia = OrderOutsideIndia?.filter((x: any) => x.Item_Id !== ItemDetails?.Item_Id);
        localStorage.setItem("OrderOutsideIndia", JSON.stringify(OrderOutsideIndia));
    }
}

export function RemoveAllOrderOutsideIndia(){
    localStorage.setItem("OrderOutsideIndia",JSON.stringify([]));
}

export function GetOrderOutsideIndia(){

//   let _MPCart : any =   localStorage.getItem("MPCart");
//     let MPCart : Array<CartModel> = [];
//     if(_MPCart !== undefined && _MPCart !== null  && _MPCart !== ""){
//         MPCart =  MPCart.concat(JSON.parse(_MPCart));
//     }

    let _OrderOutsideIndia : any =   localStorage.getItem("OrderOutsideIndia");
    let OrderOutsideIndia : Array<OrderOutsideIndiaModel> = [];
    if(_OrderOutsideIndia !== undefined && _OrderOutsideIndia !== null  && _OrderOutsideIndia !== ""){
        OrderOutsideIndia =  OrderOutsideIndia.concat(JSON.parse(_OrderOutsideIndia));
    }
    return OrderOutsideIndia;

}